import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import t from '../../../../i18n/t';
import { getNewEstDialogState } from '../../../../state/task/selectors';
import QuestionDialog from '../../categoryTime/QuestionDialog';
import ReadingPaceQuestion, { answerReadingPace } from './ReadingPaceQuestion';

/**
 * The book's "Time per page" question as an overlay, where no session popup asks it (askInPopup): a session row's ✓ in
 * the task's window. Its × and a click on the dim keep the old estimate (Petr, 2026-10-31); before, only its two
 * buttons closed it.
 */
const NewEstimateDialog = () => {
  const dispatch = useDispatch();
  const { open, data } = useSelector(getNewEstDialogState);

  if (!data || data.inPopup !== undefined) return null;
  const answer = (yes: boolean) => answerReadingPace(dispatch, data, yes);

  return (
    <QuestionDialog open={open} onDismiss={() => answer(false)} dismissLabel={t.KEEP_OLD_EST}>
      {leave => <ReadingPaceQuestion data={data} onAnswer={yes => leave(() => answer(yes))} />}
    </QuestionDialog>
  );
};

export default NewEstimateDialog;
